export const CELEBRATE = 'CELEBRATE';
export const YEARS_OF = 'YEARS OF';
export const MAKING_HISTORY = 'MAKING HISTORY.';
export const BREAKING_BARRIERS = 'BREAKING BARRIERS.';
export const EMPOWERING_WOMEN = 'EMPOWERING WOMEN.';
